declare module PIXI {
	import Layer = display.Layer;
	interface WebGLRenderer {
		_activeLayer: Layer
		_renderSessionId: number
		_lastDisplayOrder: number
		depthMode: number
		dxt: WebGLCompressedTextureS3TC;
		incDisplayOrder(): number
		setDepthMode(value: number): void
	}
}

namespace PIXI.display {
	import WebGLRenderer = PIXI.WebGLRenderer;
	import DisplayObject = PIXI.DisplayObject;
	import Transform = PIXI.Transform;
	import RenderTexture = PIXI.RenderTexture;

	export const DEPTH_MODE = {
		DEFAULT: 0,
		FRONT_TO_BACK: 1,
		BACK_TO_FRONT: 2
	};

	(Object as any).assign(WebGLRenderer.prototype, {
		_lastDisplayOrder: 0,
		_activeLayer: null,
		depthMode: 0,
		_oldInitContext: (WebGLRenderer as any).prototype._initContext,
		_initContext() {
			this._oldInitContext();
			this.dxt = this.gl.getExtension("WEBGL_compressed_texture_s3tc");
			this.gl.getExtension("OES_texture_float");
		},
		setDepthMode(value: number) {
			if (value === this.depthMode) {
				return;
			}
			this.currentRenderer.flush();
			//TODO: move to renderTarget?
			const gl = this.gl;
			if (value === DEPTH_MODE.FRONT_TO_BACK) {
				// gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
				//gl.enable(gl.BLEND);

				gl.enable(gl.DEPTH_TEST);
				gl.depthFunc(gl.LEQUAL);
				gl.depthRange(-1, 1);
				gl.clear(gl.DEPTH_BUFFER_BIT | gl.STENCIL_BUFFER_BIT);

				gl.colorMask(false, false, false, false);
				gl.depthMask(true);
			} else if (value === DEPTH_MODE.BACK_TO_FRONT) {
				gl.colorMask(true, true, true, true);
				gl.depthMask(false);
			} else {
				gl.disable(gl.DEPTH_TEST);
			}
			this.depthMode = value;
		},

		_oldRender: WebGLRenderer.prototype.render,

		render(displayObject: DisplayObject, renderTexture?: RenderTexture, clear?: boolean, transform?: Transform, skipUpdateTransform?: boolean) {
			if (!renderTexture) {
				this._lastDisplayOrder = 0;
			}
			this.depthMode = 0;
			this._activeLayer = null;
			displayObject.updateDisplay(null);
			this._oldRender(displayObject, renderTexture, clear, transform, skipUpdateTransform);
		}
	});
}
